// BetaContext.js
import { createContext, useContext, useState } from "react";

const BetaContext = createContext();

export function BetaProvider({ children }) {
  const [isBeta, setIsBeta] = useState(null); // null until user selects

  return (
    <BetaContext.Provider value={{ isBeta, setIsBeta }}>
      {children}
    </BetaContext.Provider>
  );
}

export function useBeta() {
  return useContext(BetaContext);
}
